<header>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm fixed-top main-navbar mb-3">
    <div class="container container-nav">

      <a class="navbar-brand brand-title" [routerLink]="['/']">
        Paulo Veras Web Site
      </a>

      <!-- Hamburger -->
      <button
        class="navbar-toggler menu-toggle"
        type="button"
        (click)="toggle()"
        [attr.aria-expanded]="isExpanded"
        aria-label="Toggle navigation">

        <i class="bi bi-list fs-2"></i>
      </button>

      <!-- Menu -->
      <div
        class="collapse navbar-collapse d-sm-inline-flex justify-content-end"
        [ngClass]="{ show: isExpanded }">

        <ul class="navbar-nav flex-grow">

          <!-- Dark mode -->
          <li class="nav-item">
            <button
              class="btn btn-link nav-link px-0 px-lg-2 py-2"
              (click)="toggleDarkMode()">

              <i class="fa"
                 [ngClass]="darkModeService.isDarkMode() ? 'fa-sun' : 'fa-moon'"></i>
            </button>
          </li>

          <!-- Home -->
          <li class="nav-item"
              routerLinkActive="link-active"
              [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link"
               [routerLink]="['']"
               (click)="collapse()">
              Home
            </a>
          </li>

          <!-- Dropdown -->
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle"
               href="#"
               role="button"
               data-bs-toggle="dropdown"
               aria-expanded="false">
              Artigos
            </a>

            <ul class="dropdown-menu">

              @for (tema of temas; track tema) {
                <li>
                  <a class="dropdown-item"
                     [routerLink]="['/artigos', tema.id]"
                     (click)="collapse()">
                    {{ tema.nome }}
                  </a>
                </li>
              }

              <li>
                <a class="dropdown-item"
                   href="/volei-protocol"
                   (click)="collapse()">
                  Protocolo de Jogo de Volei
                </a>
              </li>

            </ul>
          </li>

          <!-- Links -->
          <li class="nav-item"
              routerLinkActive="link-active"
              [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link"
               [routerLink]="['/link']"
               (click)="collapse()">
              Links
            </a>
          </li>

          <!-- Contacto -->
          <li class="nav-item"
              routerLinkActive="link-active"
              [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link"
               [routerLink]="['/contato']"
               (click)="collapse()">
              Contato
            </a>
          </li>

          <!-- Treino -->
          <li class="nav-item"
              routerLinkActive="link-active"
              [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link"
               [routerLink]="['/treino']"
               (click)="collapse()">
              Treino
            </a>
          </li>

          <!-- Cinema -->
          <li class="nav-item"
              routerLinkActive="link-active"
              [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link"
               [routerLink]="['/cinema']"
               (click)="collapse()">
              Cinema
            </a>
          </li>

          <div class="dropdown-divider"></div>

          <!-- Login -->
          <app-login-menu></app-login-menu>

        </ul>
      </div>
    </div>
  </nav>
</header>